import { configureStore } from "@reduxjs/toolkit";
import authReducer from "@/auth/authSlice";
import navReducer from "@/nav/navSlice";
import bidReducer from "@/sheet/bidSlice";
import actualReducer from "@/actuals/actualSlice";
import accountingBillReducer from "@/accounting_bills/accountingBillsSlice";
import aiReducer from "@/ai/aiSlice";
import gridReducer from "@/grid/spreadsheet/engine/gridSlice";

export default configureStore({
    reducer: {
        auth: authReducer,
        nav: navReducer,
        sheet: bidReducer,
        actual: actualReducer,
        accountingBill: accountingBillReducer,
        ai: aiReducer,
        grid: gridReducer,
    },
});
